<template>
  <div>
    <div class="calendar-gantt">
      <div class="calendar-gantt__items-section">
        <div class="search-section">
          <div class="search-input">
            <i class="icon-search" />
            <input
              v-model="searching"
              type="text"
              :placeholder="$t('搜尋')"
              :disabled="isLoading"
            >
          </div>
        </div>
        <div class="gantt_items">
          <a
            v-for="(ganttItem,ganttItemKey) in _ganttItems"
            :key="ganttItemKey"
            class="gantt_item"
            @click="$_onGanttItemClick(ganttItem)"
          >
            <div class="badge-list">
              <div
                v-for="(chipItem,chipKey) in ganttItem.chips"
                :key="chipKey"
                class="badge-list__item"
                :style="{backgroundColor:chipItem.color}"
              >{{ chipItem.name }}</div>
            </div>
            <div class="event-title">{{ ganttItem.name }}</div>
            <div class="event-title__tooltip">{{ ganttItem.name }}</div>
            <div class="events">
              <div
                v-for="(event,eventIndex) in ganttItem.events"
                :key="eventIndex"
                class="event"
                :style="{
                  'margin-top': event.type === 'range'
                    ? (eventIndex === 0
                    ? '34px'
                    : '36px')
                    : (eventIndex === 0
                    ? '0px'
                    : '26px')}"
              >
                <i
                  class="icon"
                  :class="`icon-${event.icon}`"
                />
                <div
                  v-if="event.type === 'range'"
                  class="name-content"
                >
                  <span class="name">{{ event.name }}</span> <span>{{ $_moment(event.date_start).format('YYYY-MM-DD') }}</span>
                </div>
                <div
                  v-else-if="event.type === 'date'|| event.type === 'text'"
                  class="name-content"
                >
                  <span class="name">{{ event.name }}</span> <span>{{ event.date || event.text }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="calendar-gantt__board">
        <div
          class="arrow arrow-left"
          @click="$_preClick()"
        >
          <i class="icon-chevron-back" />
        </div>
        <div
          class="arrow arrow-right"
          @click="$_nextClick()"
        >
          <i class="icon-chevron-forward" />
        </div>
        <div
          ref="horiScrollContainer"
          v-dragscroll.x
          class="hori-scroll-container"
        >
          <div
            class="year-section"
            :style="{width:`${bgWidth*(_endYear - _startYear +1)}px`}"
          >
            <div
              v-for="n in (_endYear - _startYear +1)"
              :key="n"
              class="year"
              :class="{active:_startYear+n-1==$_moment().year()}"
            >
              <p>{{ _startYear+n-1 }}</p>
            </div>
          </div>
          <div
            class="gantt_items"
            :style="{width:`${bgWidth*(_endYear - _startYear +1)}px`}"
          >
            <div
              class="today-line"
              :style="{left:`${$_getEventRangeLeft($_moment())}px`}"
            />
            <div
              v-for="(ganttItem,ganttItemKey) in _ganttItems"
              :key="ganttItemKey"
              class="gantt_item"
            >
              <div class="bg">
                <div
                  v-for="n in (_endYear - _startYear +1)"
                  :key="n"
                  class="bg-item"
                />
              </div>
              <div class="events">
                <div
                  v-for="(event,eventIndex) in ganttItem.events"
                  :key="eventIndex"
                  class="event"
                >
                  <div
                    v-if="event.type=='range'"
                    class="event-item-range"
                    :style="[
                      {left:`${$_getEventRangeLeft(event.date_start)}px`},
                      {width:`${$_getEventRangeWidth(event.date_start,event.date_end,ganttItem.permanent)}px`}
                    ]"
                    :class="$_getEventRangeClass(event.date_end)"
                  >
                    <div
                      class="icon"
                      :class="`icon-${event.icon}`"
                    />
                    <div class="date">
                      {{ event.date_start }}
                    </div>
                  </div>
                  <div
                    v-else-if="(event.type=='date' && !ganttItem.permanent) || event.type=='text'"
                    class="event-item-date"
                    :style="[
                      {left:`${$_getEventRangeLeft(event.date || event.text)}px`},
                    ]"
                  >
                    <div
                      class="icon"
                      :class="`icon-${event.icon}`"
                    />
                    <div class="date">
                      {{ event.date || event.text }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DotLoading v-if="isLoading && _ganttItems && _ganttItems.length"/>
  </div>
</template>
<script>
import moment from "moment";
import { dragscroll } from "vue-dragscroll";
export default {
  directives: {
    dragscroll,
  },
  props: {
    ganttItems: {
      type: Array,
      default: null,
    },
    eventTypes: Array,
    startYearExtend: {
      type: Number,
      default: 2,
    },
    endYearExtend: {
      type: Number,
      default: 2,
    },
    bgWidth: {
      type: Number,
      default: 84,
    },
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    searching: "",
    isMounted: false,
  }),
  computed: {
    _ganttItems() {
      if (!this.ganttItems) {
        return null;
      } else if (!this.searching) {
        return this.ganttItems;
      } else {
        const _ganttItems = [];
        this.ganttItems.forEach((ganttItem) => {
          if (
            ganttItem.name.toLowerCase().includes(this.searching.toLowerCase())
          ) {
            _ganttItems.push(ganttItem);
          }
        });
        return _ganttItems;
      }
    },
    _todayMoment() {
      return moment();
    },
    _startYear() {
      let _startYear = moment().year();
      if (!this.ganttItems || this.ganttItems.length === 0)
        return _startYear - this.startYearExtend;
      this.ganttItems.forEach((ganttItem) => {
        ganttItem.events.forEach((event) => {
          if (event.type == "range") {
            const tarYear = moment(event.date_start).year();
            if (tarYear < _startYear) {
              _startYear = tarYear;
            }
          } else if (event.type == 'date' || event.type == 'text') {
            const tarYear = moment(event.date || event.text).year();
            if (tarYear < _startYear) {
              _startYear = tarYear;
            }
          }
        });
      });
      return _startYear - this.startYearExtend;
    },
    _endYear() {
      let _endYear = moment().year();
      if (!this.ganttItems || this.ganttItems.length === 0)
        return _endYear + this.endYearExtend;
      this.ganttItems.forEach((ganttItem) => {
        ganttItem.events.forEach((event) => {
          if (ganttItem.permanent) {
            _endYear = moment().year() + 87;
          } else if (event.type == "range") {
            const tarYear = moment(event.date_end).year();
            if (tarYear > _endYear) {
              _endYear = tarYear;
            }
          } else if (event.type == "date" || event.type == "text") {
            const tarYear = moment(event.date || event.text).year();
            if (tarYear > _endYear) {
              _endYear = tarYear;
            }
          }
        });
      });
      return _endYear + this.endYearExtend;
    },
  },
  watch: {
    _startYear: {
      deep: true,
      handler() {
        if (!this.isMounted && this.ganttItems) {
          this.isMounted = true;
          this.$_scrollInit();
        }
      },
    },
  },
  mounted() {
    this.$_scrollInit();
  },
  methods: {
    $_onGanttItemClick(ganttItem) {
      this.$emit("event-click", ganttItem);
    },
    $_scrollInit() {
      setTimeout(() => {
        if (!this.$refs.horiScrollContainer) return;
        const range = moment().year() - this._startYear;
        this.$refs.horiScrollContainer.scrollLeft =
          ((range * 12 - 10) * this.bgWidth) / 12;
      }, 0);
    },
    $_moment(date) {
      return moment(date);
    },
    $_getEventRangeClass(date_end) {
      const diffYears = moment(date_end).diff(this._todayMoment, "years");
      if (diffYears < 0) {
        return "disabled";
      } else if (diffYears == 0) {
        return "notice";
      } else {
        return "normal";
      }
    },
    $_getEventRangeWidth(date_start, date_end, permanent) {
      const dateMonthRange = moment(date_end).diff(
        moment(date_start),
        "months"
      );
      if (permanent) {
        const permanentRangeStart = this._endYear - moment(date_start).year();
        return ((permanentRangeStart * 12 + 1) * this.bgWidth) / 12;
      }
      return ((dateMonthRange + 1) * this.bgWidth) / 12;
    },
    $_getEventRangeLeft(date_start) {
      const dateMonthRange = moment(date_start).diff(
        moment(`${this._startYear}-01-01`),
        "months"
      );
      return ((dateMonthRange + 1) * this.bgWidth) / 12;
    },
    $_getPermanentDate(date, permanent) {
      return permanent ? permanent : moment(date).format("YYYY-MM-DD");
    },
    $_preClick() {
      const range = moment().year() - this._startYear;
      this.$refs.horiScrollContainer.scrollLeft =
        this.$refs.horiScrollContainer.scrollLeft - range * 6 + 10;
    },
    $_nextClick() {
      const range = moment().year() - this._startYear;
      this.$refs.horiScrollContainer.scrollLeft =
        this.$refs.horiScrollContainer.scrollLeft + range * 6 + 10;
    },
  },
};
</script>